import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
	selector: 'sh-basic-device-image',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './basic-device-image.component.html',
	styleUrl: './basic-device-image.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasicDeviceImageComponent {
	public imagePath = input.required<string>();
}
